import {
  Box,
  Button,
  Container,
  Grid,
  Flex,
  Indicator,
  Loader,
  Select,
  SimpleGrid,
  createStyles,
  Title,
  Text,
  TextInput,
  Popover,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionCheck from "../../../components/AccordionCheck";
import { getAllFacilities } from "../../../services";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import {
  addTask,
  changeTaskStatus,
  getClientTask,
} from "../../../services/task";
import { decrypt } from "../../../utils";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { CommentDrawer } from "./CommentDrawer";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { IconChevronDown } from "@tabler/icons-react";
import { DateInput, TimeInput } from "@mantine/dates";
import { getAllSignatures } from "../../../services/signature";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { getAllPlans } from "../../../services/supportplan";
import { taskAdlHiddenFields } from ".";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
    height: "100vh",
  },
  container: {
    // border: "1px solid #dee2e6",
    margin: "10px 20px 0  8px",
  },
  mainContainer: {
    borderRadius: "15px",
    backgroundColor: "#ffffff",
    padding: "20px 10px 10px 20px",
    marginBottom: "20px",
  },
  topContainer: {
    borderRadius: "15px",
    backgroundColor: "#ffffff",
    padding: "10px 10px 30px 10px",
    marginBottom: "20px",
  },
  checkBoxParent: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    // margin: "20px",
    "@media (min-width:992px)": {
      padding: "20px 140px",
    },
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
  },
  mainHeading: {
    margin: "0",
  },
  draft: {
    p: {
      margin: "0",
      border: "1px solid #fab005",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "#fab005",
    },
  },
  completed: {
    p: {
      margin: "0",
      border: "1px solid green",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "green",
    },
  },
  expired: {
    p: {
      margin: "0",
      border: "1px solid red",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "red",
    },
  },
  detail: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  detail: {
    span: {
      color: "#A8A8A8",
    },
  },
  detail: {
    p: {
      margin: "0",
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  info: {
    p: {
      margin: "0",
      textAlign: "center",
    },
  },
  btnFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "60px 0 0 0",
    gap: "20px",
  },
  divGap: {
    // margin: "20px 0",
    alignItems: "center",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
  },
  newTaskBtn: {
    textAlign: "end",
    "@media (max-width:600px)": {
      textAlign: "center",
      margin: "10px 0 10px 0",
    },
  },
  topBarContent: {
    margin: "5px 0 10px 0",
    "@media (max-width:600px)": {
      textAlign: "center",
      margin: "5px 0 0 0",
    },
  },
  topBarDate: {
    color: "#A3A3A3",
    fontSize: "small",
  },
  iconStyle: {
    width: "20px",
    height: "20px",
    color: "#94A3B8",
  },
  commentBtnStyle: {
    boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#F4F3FF",
    color: "#6C63FF",
  },
  commentFlex: {
    "@media (max-width:600px)": {
      marginTop: "20px",
    },
  },
  signatureImg: {
    width: 250,
    height: "auto",
  },
  commentRequiredPopover: {
    padding: "8px 16px",
    backgroundColor: "#FDA29B",
    fontSize: 16,
    fontWeight: 500,
    color: "#000",
    fontFamily: "Inter",
  },
}));

export const levelOfNeedOptions = [
  "LON 1 - Intermittent",
  "LON 5 - Limited",
  "LON 8 - Extensive",
  "LON 6 - Pervasive",
  "LON 9 - Pervasive+",
];
// If the task name contains "(for off-site only)", show it only for "Off-Site"
export const isCommunityIntegration =
  "Community Integration (for off-site only)";

export const ADL_ACTIVE_PLAN_TASK_TYPE_ID = "6989b426b0db571633269e6a";
export const ADL_TASK_TRIGGER_ID = "65e86998f28c4e25697e839f";

const AddTask = ({
  embedded,
  embeddedClientId,
  embeddedTaskType,
  embeddedTaskTypeName,
  onComplete,
}) => {
  const { classes } = useStyles();
  const isMoobileScreen = useMediaQuery("(max-width: 600px)");
  const isTabletScreen = useMediaQuery("(max-width: 1030px)");
  const [opened, { open, close }] = useDisclosure(false);
  const location = useLocation();
  const editstate =
    !embedded && location.state?.fromModal ? location.state : null;
  const _navigate = useNavigate();
  const navigate = embedded ? () => onComplete?.() : _navigate;
  const [state, setState] = useState(null);
  const [taskTypeDetails, setTypeDetails] = useState(null);
  console.log("🚀 ~ AddTask ~ taskTypeDetails:", taskTypeDetails);
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState([]);
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingClientTasks, setLoadingClientTasks] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [clientValue, setClientValue] = useState({});
  const [clientData, setClientData] = useState("");
  const [activePlan, setActvePlan] = useState(null);
  console.log("🚀 ~ AddTask ~ activePlan:", activePlan);
  const [taskDateValue, setTaskDateValue] = useState(new Date());
  const { tasks, loadingTasks } = useSelector((state) => state?.task);
  const { allPatients } = useSelector((state) => state?.patient);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { profile } = useSelector((state) => state.profile);
  let userType = profile?.user?.type;
  let taskType = embedded
    ? embeddedTaskType
    : editstate?.fromModal === true
      ? editstate?.taskType?.id
      : localStorage.getItem("taskType");
  let taskTypeName = embedded
    ? embeddedTaskTypeName
    : localStorage.getItem("taskTypeName");
  const _preselectedClient = embedded
    ? embeddedClientId
    : localStorage.getItem("preselectedClient");
  const preselectedClient =
    _preselectedClient && _preselectedClient !== "undefined"
      ? _preselectedClient
      : null;
  const { staff } = useSelector((state) => state?.staff);
  const { allSignature } = useSelector((state) => state?.signature);

  const [selectedStaff, setSelectedStaff] = useState();

  const selectedStaffData = staff?.staffs?.find(
    (s) => s?.id === selectedStaff || s?._id === selectedStaff,
  );
  const isIndividualizedSkillsType =
    taskTypeName === "Individualized Skills and Socialization Log";
  const [requiredCheckedFields, setRequiredCheckedFields] = useState([]);
  const [
    commentRequiredPopoverOpened,
    { open: commentRequiredPopoverOpen, close: commentRequiredPopoverClose },
  ] = useDisclosure(false);

  const { allPlans } = useSelector((state) => state?.supportPlan);

  useEffect(() => {
    setTaskDateValue(new Date());
    getAllPlans();
    // Clean up preselected client after consuming it
    if (preselectedClient && !embedded) {
      localStorage.removeItem("preselectedClient");
    }
  }, []);
  useEffect(() => {
    setSelectedStaff(profile?.user?.id);
    form.setFieldValue("staff", profile?.user?.id);
  }, []);

  useEffect(() => {
    if (editstate?.fromModal === true) {
      setLoading(true);
      setState(editstate);
      setTypeDetails(editstate?.taskType);
      // setNotes(editstate?.notes);
      // setChecks(editstate?.fieldsDone);
      setLoading(false);
      setHasEnded(editstate?.hasEnded);
      setLoadingClientTasks(true);
      setLoadingClientTasks(false);
      getClientTask({
        client: editstate?.client?.id,
        type: editstate?.taskType?.id,
      });
      form.setFieldValue("client", editstate?.client?.id);
      form.setFieldValue("facility", editstate?.facility?.id);
      form.setFieldValue(
        "shift",
        editstate?.shift?.[editstate?.shift?.length - 1]?.name,
      );
    } else {
      setTaskDateValue(new Date());
    }
  }, [editstate]);

  useEffect(() => {
    getAllPatientsModal();
    getAllStaff("all");
    getAllFacilities("all");
    getAllSignatures();
  }, []);

  const form = useForm({
    initialValues: {
      client: state?.client ? state?.client?.id : preselectedClient || "",
      facility: state?.facility ? state?.facility?.id : "",
      shift: "",
      date: new Date(),
    },
    validate: {
      client: (value) => (value ? null : "Client is Required"),
      facility: (value) => (value ? null : "Facility is Required"),
      shift: (value) =>
        value
          ? // value || state?.shift?.find((item) => item.staff === profile?.user?.id)
            null
          : "Shift is Required",
      date: (value) => (value ? null : "Date is Required"),
    },
  });

  async function fetchActivePlan(facilityId) {
    if (taskTypeName === "Activities of Daily Living") {
      // if (form?.values?.client) {
      let activePlan = allPlans?.find((v) => {
        const match = v?.client?._id === form.values?.client; // String comparison
        const facMatch = v?.facility?._id === facilityId; // String comparison
        return (
          match &&
          facMatch &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true &&
          v?.servicePlanData?.activitiesOfDailyLiving
        );
      })?.servicePlanData;

      // }
      let initialChecks = [];
      if (activePlan?.activitiesOfDailyLiving) {
        initialChecks = activePlan?.activitiesOfDailyLiving?.fieldsDone?.map(
          (fieldDone) => ({
            field: fieldDone.field,
            shift: fieldDone.shift,
            // textField: fieldDone.textField || "",
            // checked: true,
            textField: "",
            checked: false,
          }),
        );

        // setChecks(initialChecks);
        setChecks([]);
      } else {
        setChecks([]);
      }

      setActvePlan(activePlan);
      return { activePlan, initialChecks };
    } else {
      return null;
    }
  }

  const resetForm = () => {
    form?.reset();
  };

  const handleTimeChange = (field, value) => {
    form.setFieldValue(field, value);
  };

  const [selectedFacilityDetails, setSelectedFacilityDetails] = useState(null);

  // Auto-fill facility details when facility is selected
  useEffect(() => {
    if (form.values.facility) {
      const facilityDetails = allFacilities?.facilities?.find(
        (f) => f?.id === form.values.facility,
      );
      setSelectedFacilityDetails(facilityDetails);
    } else {
      setSelectedFacilityDetails(null);
    }
  }, [form.values.facility, allFacilities]);

  // Auto-fill or clear Level of Need when client changes
  useEffect(() => {
    if (form.values.client && allPatients?.length) {
      const selectedClient = allPatients.find(
        (p) => p?.id === form.values.client,
      );

      const clientLevel =
        selectedClient?.form1?.levelofneed?.replace(/–/g, "-") || "";

      form.setFieldValue("levelofneed", clientLevel);
    } else {
      form.setFieldValue("levelofneed", "");
    }
  }, [form.values.client, allPatients]);

  const completePreviousTask = async () => {
    await changeTaskStatus(clientValue?.task?._id, false);
  };

  useEffect(() => {
    if (isIndividualizedSkillsType) {
      form.setFieldValue(
        "placeOfService",
        selectedFacilityDetails?.address || "",
      );
      form.setFieldValue("state", selectedFacilityDetails?.state || "");
      form.setFieldValue("zipcode", selectedFacilityDetails?.zipcode || "");
      form.setFieldValue(
        "providerLicense",
        selectedFacilityDetails?.providerLicense || "",
      );
    }
  }, [selectedFacilityDetails]);

  const onSave = async (values) => {
    if (taskTypeDetails?.general !== true) {
      const invalidFields = [];
      taskTypeDetails.subTasks.forEach((subTask) => {
        subTask.fields.forEach((field) => {
          if (field.required) {
            const checkEntry = checks.find((c) => c.field === field._id);
            if (
              checkEntry &&
              (!checkEntry.textField || checkEntry.textField.trim() === "")
            ) {
              invalidFields.push(field);
            }
          }
        });
      });

      if (invalidFields.length > 0) {
        setRequiredCheckedFields(invalidFields);
        return;
      }
    }

    if (taskTypeDetails?.commentRequired && comments?.length === 0) {
      commentRequiredPopoverOpen();
      return;
    }

    setLoading(true);
    let payload;

    let formattedComments = comments?.map((_c) => {
      if (_c?.text) {
        return _c?.text;
      }
    });

    payload = {
      ...values,
      isStarted: true,
      notes,
      comments: formattedComments,
      fieldsDone: checks,
      taskType:
        // activePlan?.length > 0 &&
        // activePlan[0]?.activitiesOfDailyLiving?.fieldsDone?.length > 0
        //   ? ADL_ACTIVE_PLAN_TASK_TYPE_ID
        //   :
        taskType,
    };

    // if (
    //   activePlan.length > 0 &&
    //   Object.keys(activitiesOfDailyLiving).length > 0
    // ) {
    //   payload = {
    //     ...payload,
    //     activitiesOfDailyLiving,
    //   };
    // }

    if (isIndividualizedSkillsType) {
      payload = {
        ...payload,
        providerLicense: values?.providerLicense,
        placeOfService: form?.values?.placeOfService || "",
        state: form?.values?.state || "",
        zipcode: form?.values?.zipcode || "",
        site: values?.site,
        levelofneed: values?.levelofneed,
        timeIn: values?.timeIn,
        timeOut: values?.timeOut,
      };
    }

    let clientTask = await getClientTask({
      client: values?.client,
      type: taskType,
    });

    if (clientTask?.task) {
      await addTask(payload, resetForm, navigate, setLoading);
    } else {
      await addTask(payload, resetForm, navigate, setLoading);
      setLoading(false);
    }
  };

  const AuctionTimer = () => {
    const [remainingTime, setRemainingTime] = useState("");

    useEffect(() => {
      let interval;
      interval = setInterval(() => {
        const now = moment();
        const end = moment(state?.taskEndAt);
        const duration = moment.duration(end.diff(now));
        if (duration.asSeconds() <= 0) {
          clearInterval(interval);
          setRemainingTime("Task Ended!");
          setHasEnded(true);
        } else {
          const days = Math.floor(duration.asDays());
          const hours = String(duration.hours()).padStart(2, "0");
          const minutes = String(duration.minutes()).padStart(2, "0");
          const seconds = String(duration.seconds()).padStart(2, "0");
          setRemainingTime(
            days === 0
              ? `${hours}h ${minutes}m ${seconds}s`
              : `${days}d ${hours}h ${minutes}m ${seconds}s`,
          );
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [state?.taskEndAt]);

    return (
      <>
        <div style={{ minWidth: "130px" }}>
          <p
            style={{
              textTransform:
                remainingTime === "Task Ended!" ? "initial" : "lowercase",
              fontSize: remainingTime === "Task Ended!" ? "16px" : "18px",
            }}
          >
            {remainingTime || "-"}
          </p>
        </div>
      </>
    );
  };

  const activeStaffData =
    staff?.staffs
      ?.filter((_s) => _s.active === true && !_s.deleted)
      ?.map((_s) => ({
        value: _s.id,
        label: _s.name,
      })) || [];

  const filteredPatients =
    profile?.user?.id === selectedStaff
      ? allPatients
          ?.filter((p) => p?.active === true && p?.deleted === false)
          .map((data) => ({
            value: data?.id,
            label: data?.name,
          }))
      : allPatients
          ?.filter(
            (patient) =>
              patient?.active === true &&
              patient?.deleted === false &&
              Array.isArray(patient?.staff) &&
              patient.staff.some(
                (staff) =>
                  staff.staffId === selectedStaff && staff.isAssign === true,
              ),
          )
          .map((p) => ({
            value: p.id,
            label: p.name,
          }));

  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff && staff === selectedStaff) || (admin && admin === selectedStaff),
  );

  return (
    <Container fluid className={classes.content} p={0}>
      {!embedded && <AppNavbar title={"Task"} profile={profile} />}
      {!embedded && (
        <Flex
          align="center"
          gap={5}
          mt={5}
          onClick={() => _navigate("/home/tasks")}
          style={{ cursor: "pointer", width: "fit-content" }}
        >
          <MdKeyboardArrowLeft size={30} />
          <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
            Back
          </Text>
        </Flex>
      )}
      {!embedded && (
        <Title order={3} mt={5} ml={10}>
          Add Task
        </Title>
      )}
      <Box className={classes.container}>
        <form onSubmit={form?.onSubmit((values) => onSave(values))}>
          <Box className={classes.topContainer}>
            <div className={classes.flex}>
              {/* <h2 className={classes.mainHeading}>{taskTypeName || ""}</h2> */}
              {state?.status === "draft" && !hasEnded && (
                <div className={classes.draft}>
                  <p>Draft</p>
                </div>
              )}
              {hasEnded && (
                <div className={classes.completed}>
                  <p>Completed</p>
                </div>
              )}
              {state?.status === "expired" && (
                <div className={classes.expired}>
                  <p>Expired</p>
                </div>
              )}
            </div>
            <div className={classes.divGap}>
              <Grid justify="flex-start" align="center" gap={20}>
                <Grid.Col xs={3} sm={3} md={3} lg={5} xl={5}>
                  <h2 className={classes.topBarContent}>
                    {taskTypeName || ""}
                  </h2>
                </Grid.Col>
                <Grid.Col p={0} xs={6} sm={6} md={3} lg={3}>
                  {!isIndividualizedSkillsType && (
                    <DateInput
                      value={taskDateValue}
                      onChange={setTaskDateValue}
                      label="Date"
                      placeholder="Select Date"
                      radius={"md"}
                      {...form.getInputProps("date")}
                      maxDate={new Date()}
                    />
                  )}
                  {/* <p
                    className={`${classes.topBarContent} ${classes.topBarDate}`}
                  >
                    {moment(state?.createdAt).format("dddd, MMMM Do, YYYY")}
                  </p> */}
                </Grid.Col>
                <Grid.Col xs={3} sm={3} md={3} className={classes.newTaskBtn}>
                  {staffSignature?.signature ||
                  staffSignature?.signatureImage ? (
                    <Flex justify="flex-end">
                      <img
                        src={
                          decrypt(staffSignature?.signature) ||
                          decrypt(staffSignature?.signatureImage)
                        }
                        alt="signature"
                        className={classes.signatureImg}
                      />
                    </Flex>
                  ) : staffSignature?.signatureText ? (
                    <Text fz={32} fw={400} ff="Island Moments" color="#171717">
                      {staffSignature?.signatureText}
                    </Text>
                  ) : null}
                  {/* <Button
                    className={classes.taskBtn}
                    variant="outline"
                    color="green"
                    radius="md"
                    size="xs"
                  >
                    New Task
                  </Button> */}
                  {/* <NewTaskModal className={classes.taskBtn} /> */}
                </Grid.Col>
              </Grid>
              <SimpleGrid
                cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                mt={10}
                // className={classes.divGap}
              >
                <div className={classes.detail}>
                  {/* <p>
                  <strong>Started By Staff: </strong> {state?.startedBy?.name}
                </p> */}
                  <Select
                    label="Staff Name"
                    placeholder={
                      state?.startedBy
                        ? state?.startedBy?.name
                        : profile?.user?.name
                    }
                    disabled={userType === "staff" ? true : false}
                    data={activeStaffData}
                    onChange={(value) => {
                      setSelectedStaff(value);
                      form.setFieldValue("staff", value);
                      form.setFieldValue("client", "");
                      form.setFieldValue("facility", "");
                    }}
                    value={form.values.staff}
                    radius={"md"}
                    rightSection={
                      <IconChevronDown className={classes.iconStyle} />
                    }
                  />
                </div>
                <div className={classes.info}>
                  <Select
                    id="add-task-client-name"
                    label="Client Name"
                    radius={"md"}
                    // value={state?.client?.id}
                    rightSectionPointerEvents="none"
                    rightSection={
                      <IconChevronDown className={classes.iconStyle} />
                    }
                    placeholder={
                      state?.client
                        ? decrypt(state?.client?.name, false)
                        : "Select an option"
                    }
                    data={filteredPatients || []}
                    {...form.getInputProps("client")}
                    nothingFound="Clients Not Assigned"
                    disabled={!!preselectedClient}
                  />
                </div>
                <div className={classes.info}>
                  <Select
                    label="Facility"
                    radius={"md"}
                    rightSectionPointerEvents="none"
                    rightSection={
                      <IconChevronDown className={classes.iconStyle} />
                    }
                    placeholder={
                      state?.client ? state?.facility?.name : "Select an option"
                    }
                    // value={state?.facility?.id}
                    value={form.values.facility}
                    data={
                      allFacilities?.facilities?.map((data) => {
                        let filteredPatient = allPatients?.find(
                          (item) =>
                            item.id == form.getTransformedValues()?.client,
                        );
                        let facilityDisabled =
                          filteredPatient?.facilityId?.find(
                            (_f) => _f?.id == data?.id,
                          )
                            ? false
                            : true;
                        return {
                          value: data?.id,
                          label: data?.name,
                          disabled: facilityDisabled,
                        };
                      }) || []
                    }
                    onChange={async (value) => {
                      setLoadingClientTasks(true);
                      form.setFieldValue("facility", value);
                      // let facility = allPatients?.find(
                      //   (item) => item.id === value
                      // )?.facilityId?.id;
                      // form.setFieldValue("facility", facility);
                      await fetchActivePlan(value);
                      let data = await getClientTask({
                        client: form.values?.client,
                        type:
                          // _ap?.activePlanArray[0]?.activitiesOfDailyLiving
                          //   ?.fieldsDone
                          //   ? ADL_ACTIVE_PLAN_TASK_TYPE_ID
                          //   :
                          taskType,
                      });
                      setClientValue(data);
                      if (data?.task) {
                        setClientData(data?.task);
                        setState(null);
                        setTypeDetails(data?.taskType);
                        setLoadingClientTasks(false);
                        setChecks([]);
                        setLoadingClientTasks(false);
                        setRequiredCheckedFields([]);
                      } else {
                        setState(null);
                        setTypeDetails(data?.taskType);
                        // setTypeDetails(data?.taskType);
                        setLoadingClientTasks(false);
                        // setChecks([]);
                        setRequiredCheckedFields([]);
                      }
                    }}
                    nothingFound="Facilities Not Assigned"
                  />
                </div>
                {isIndividualizedSkillsType ? (
                  <div className={classes.detail}>
                    <TextInput
                      label="License Number"
                      radius="md"
                      // readOnly
                      placeholder="Add License Number"
                      {...form.getInputProps("providerLicense")} // License Number is same as Provider License
                    />
                  </div>
                ) : (
                  <div className={classes.info}>
                    {state?.shift?.find(
                      (item) => item?.staff?.id === profile?.user?.id,
                    ) ? (
                      <Select
                        radius={"md"}
                        label="Shift"
                        rightSectionPointerEvents="none"
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                        placeholder={
                          state?.shift?.find(
                            (item) => item?.staff?.id === profile?.user?.id,
                          )?.name
                        }
                        // disabled={true}
                        value={
                          state?.shift?.find(
                            (item) => item?.staff?.id === profile?.user?.id,
                          )?.name
                        }
                        data={["Morning", "Evening", "Night"]}
                        {...form.getInputProps("shift")}
                      />
                    ) : (
                      <Select
                        id="add-task-staff"
                        label="Shift"
                        radius={"md"}
                        placeholder={"Select an option"}
                        rightSectionPointerEvents="none"
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                        data={["Morning", "Evening", "Night"]}
                        {...form.getInputProps("shift")}
                      />
                    )}
                  </div>
                )}
                {state?.dateTime ||
                  (state?.createdAt && (
                    <div className={classes.detail}>
                      <p>
                        <strong>Date Created: </strong>
                        {state?.dateTime &&
                          moment(
                            state?.dateTime
                              ? state?.dateTime
                              : state?.createdAt,
                          ).format("MM-DD-YYYY")}
                        at{" "}
                        {state?.dateTime
                          ? moment(state?.dateTime).format("hh:mm a")
                          : "-"}
                      </p>
                    </div>
                  ))}
                {state?.dateTime && state?.taskEndAt && (
                  <div className={classes.detail}>
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <strong>Time Remaining: </strong>{" "}
                      {state?.dateTime && state?.taskEndAt ? (
                        <AuctionTimer />
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>
                )}
              </SimpleGrid>
              {isIndividualizedSkillsType && (
                <>
                  <Grid mt={10}>
                    <Grid.Col
                      span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 6}
                    >
                      <TextInput
                        label="Place of Service"
                        radius="md"
                        variant="default"
                        placeholder="Place of Service"
                        {...form.getInputProps("placeOfService")}
                      />
                    </Grid.Col>

                    <Grid.Col
                      span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                    >
                      <TextInput
                        label="State"
                        radius="md"
                        variant="default"
                        placeholder="State"
                        {...form.getInputProps("state")}
                      />
                    </Grid.Col>

                    {/* Zip Code - 25% width */}
                    <Grid.Col
                      span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                    >
                      <TextInput
                        label="Zip Code"
                        radius="md"
                        placeholder="Zip Code"
                        {...form.getInputProps("zipcode")}
                      />
                    </Grid.Col>
                  </Grid>
                  <SimpleGrid
                    cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                    mt={10}
                  >
                    <div className={classes.detail}>
                      <Select
                        id="add-task-staff"
                        label="Site"
                        radius={"md"}
                        placeholder={"Select Site"}
                        rightSectionPointerEvents="none"
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                        data={["On-Site", "Off-Site"]}
                        {...form.getInputProps("site")}
                      />
                    </div>
                    <div className={classes.detail}>
                      <DateInput
                        value={taskDateValue}
                        onChange={setTaskDateValue}
                        label="Date"
                        placeholder="Select Date"
                        radius={"md"}
                        {...form.getInputProps("date")}
                        maxDate={new Date()}
                      />
                    </div>
                    <div className={classes.info}>
                      {state?.shift?.find(
                        (item) => item?.staff?.id === profile?.user?.id,
                      ) ? (
                        <Select
                          radius={"md"}
                          label="Shift"
                          rightSectionPointerEvents="none"
                          rightSection={
                            <IconChevronDown className={classes.iconStyle} />
                          }
                          placeholder={
                            state?.shift?.find(
                              (item) => item?.staff?.id === profile?.user?.id,
                            )?.name
                          }
                          // disabled={true}
                          value={
                            state?.shift?.find(
                              (item) => item?.staff?.id === profile?.user?.id,
                            )?.name
                          }
                          data={["Morning", "Evening", "Night"]}
                          {...form.getInputProps("shift")}
                        />
                      ) : (
                        <Select
                          id="add-task-staff"
                          label="Shift"
                          radius={"md"}
                          placeholder={"Select an option"}
                          rightSectionPointerEvents="none"
                          rightSection={
                            <IconChevronDown className={classes.iconStyle} />
                          }
                          data={["Morning", "Evening", "Night"]}
                          {...form.getInputProps("shift")}
                        />
                      )}
                    </div>
                    <div className={classes.info}>
                      {/* <Select
                        id="level-of-care"
                        searchable
                        label="Level of Need"
                        data={levelOfNeedOptions}
                        radius="md"
                        placeholder="Level of Need"
                        {...form.getInputProps("levelofneed")}
                        readOnly
                      /> */}

                      <Select
                        id="level-of-care"
                        searchable
                        label="Level of Need"
                        data={levelOfNeedOptions}
                        radius={"md"}
                        placeholder="Select Level of Need"
                        {...form.getInputProps("levelofneed")}
                        rightSection={
                          <IconChevronDown className={classes.iconStyle} />
                        }
                      />
                    </div>
                  </SimpleGrid>
                  <SimpleGrid
                    cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                    mt={10}
                  >
                    <TimeInput
                      label="Time In"
                      format="12"
                      // className={classes.datePicker}
                      icon={
                        <img
                          style={{ width: "20px" }}
                          src={"/assets/images/clock.png"}
                          alt="Icon"
                        />
                      }
                      value={form.values.timeIn || ""}
                      onChange={(e) => {
                        const isSafari = /^((?!chrome|android).)*safari/i.test(
                          navigator.userAgent,
                        );
                        let time = e.target.value
                          .split(":")
                          ?.slice(0, 2)
                          ?.join(":");

                        isSafari
                          ? handleTimeChange("timeIn", time)
                          : handleTimeChange("timeIn", time);
                      }}
                    />
                    <TimeInput
                      label="Time Out"
                      format="12"
                      // className={classes.datePicker}
                      icon={
                        <img
                          style={{ width: "20px" }}
                          src={"/assets/images/clock.png"}
                          alt="Icon"
                        />
                      }
                      value={form.values.timeOut || ""}
                      onChange={(e) => {
                        const isSafari = /^((?!chrome|android).)*safari/i.test(
                          navigator.userAgent,
                        );
                        let time = e.target.value
                          .split(":")
                          ?.slice(0, 2)
                          ?.join(":");

                        isSafari
                          ? handleTimeChange("timeOut", time)
                          : handleTimeChange("timeOut", time);
                      }}
                    />
                  </SimpleGrid>
                </>
              )}
            </div>
          </Box>
          <div>
            <h3>Task List</h3>
          </div>
          <Box className={classes.mainContainer}>
            <Box
              className={`${classes.mainContainer} ${classes.checkBoxParent}`}
            >
              {loadingClientTasks ? (
                <div
                  style={{
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Loader size={40} color="yellow" />
                </div>
              ) : (
                <>
                  {/* Conditionally render ActivitiesOfDailyLivingStep if activePlan has data */}
                  {/* {activePlan.length > 0 &&
                  Object.keys(activitiesOfDailyLiving).length > 0 ? (
                    <Box mb={20}>
                      <ActivitiesOfDailyLivingStep
                        data={activitiesOfDailyLiving}
                        onChange={handleActivitiesOfDailyLivingChange}
                        view={false}
                        errors={{}}
                        isTask={true}
                      />
                    </Box>
                  ) : null} */}

                  {/* Regular task grid */}
                  <SimpleGrid
                    cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
                  >
                    {taskTypeDetails?.subTasks
                      ?.filter((task) => {
                        if (task?.task?.name === isCommunityIntegration) {
                          return form.values.site === "Off-Site";
                        }
                        if (task?.task?.name === "Meals") return true;
                        if (task?.task?.name === "Body Care" && activePlan)
                          return false;
                        if (
                          taskTypeName === "Activities of Daily Living" &&
                          !activePlan &&
                          (task?.task?.name === "Hygiene" ||
                            task?.task?.name === "Nutrition and Hydration")
                        ) {
                          return false;
                        }

                        //   // If activePlan has fieldsDone, only show subtasks that have matching fields
                        if (
                          activePlan?.activitiesOfDailyLiving?.fieldsDone
                            ?.length > 0
                        ) {
                          const planFieldIds =
                            activePlan?.activitiesOfDailyLiving.fieldsDone.map(
                              (fd) => fd.field,
                            );

                          // Check if any field in this subtask matches the plan's fields
                          const hasMatchingField = task?.fields?.some((field) =>
                            planFieldIds.includes(field._id),
                          );

                          return hasMatchingField;
                        }
                        return true;
                      })
                      ?.map((tasks) => {
                        const subTaskName = tasks?.task?.name;

                        const shouldHideFields =
                          taskTypeName === "Activities of Daily Living" &&
                          !activePlan;

                        // let filteredFields = shouldHideFields
                        //   ? tasks?.fields?.filter(
                        //       (field) =>
                        //         !taskAdlHiddenFields[subTaskName]?.includes(
                        //           field?.name,
                        //         ),
                        //     ) || []
                        //   : tasks?.fields || [];

                        let filteredFields = null;

                        if (subTaskName === "Meals") {
                          filteredFields = tasks?.fields || [];
                        } else if (
                          activePlan?.activitiesOfDailyLiving?.fieldsDone
                            ?.length > 0
                        ) {
                          const planFieldIds =
                            activePlan?.activitiesOfDailyLiving?.fieldsDone?.map(
                              (fd) => String(fd.field),
                            ) || [];

                          // Filter fields: only include fields that exist in planFieldIds
                          filteredFields = (tasks?.fields || []).filter(
                            (field) => planFieldIds.includes(String(field._id)),
                          );

                          if (shouldHideFields) {
                            filteredFields = filteredFields.filter(
                              (field) =>
                                !taskAdlHiddenFields[subTaskName]?.includes(
                                  field?.name,
                                ),
                            );
                          }
                        } else {
                          filteredFields = shouldHideFields
                            ? tasks?.fields?.filter(
                                (field) =>
                                  !taskAdlHiddenFields[subTaskName]?.includes(
                                    field?.name,
                                  ),
                              ) || []
                            : tasks?.fields || [];
                        }

                        return (
                          <div>
                            <AccordionCheck
                              type={"add"}
                              data-testid="task-grid"
                              tasks={tasks}
                              // Data={filteredFields}
                              Data={filteredFields}
                              // <-- filtered + unchecked fields
                              // checksDone={tasks?.fieldsDone || []}
                              checksDone={[]}
                              activityFields={
                                clientValue?.task?.client?._id ===
                                  clientData?.client?._id &&
                                clientValue?.task?.facility?._id ===
                                  clientData?.facility?._id
                                  ? clientData?.fieldsDone
                                  : []
                              }
                              Heading={tasks?.task?.name}
                              setChecks={setChecks}
                              checks={checks}
                              userType={userType}
                              userId={profile?.user?.id}
                              shift={form.getInputProps("shift")?.value}
                              profile={profile}
                              selectedStaff={form.values.staff}
                              selectedStaffData={selectedStaffData}
                              requiredCheckedFields={requiredCheckedFields}
                              activePlan={activePlan}
                            />
                          </div>
                        );
                      })}
                  </SimpleGrid>
                </>
              )}
            </Box>

            <div>
              {/* <h3>Additional Notes</h3> */}
              {/* <div className={classes.flex}>
              <Radio label="Yes" />
              <Radio label="No" />
            </div> */}
              {/* <div className={classes.divGap}>
                <Textarea
                  id="additional-note"
                  defaultValue={notes}
                  onChange={(e) => {
                    setNotes(e.target.value);
                  }}
                  disabled={hasEnded}
                  minRows={4}
                  style={{ height: "auto" }}
                />
              </div> */}
              {!hasEnded && (
                <div className={classes.btnFlex}>
                  <Button
                    w={200}
                    size="lg"
                    color="gray"
                    radius={"md"}
                    variant="outline"
                    onClick={() => {
                      navigate("/home/tasks");
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    id="ad-task-start"
                    w={200}
                    size="lg"
                    c={"#000"}
                    type="submit"
                    radius={"md"}
                    color="yellow"
                    loading={loading}
                  >
                    Save
                    {/* {state?.startedBy ? "Save" : "Start"} */}
                  </Button>
                </div>
              )}
            </div>
            <Flex className={classes.commentFlex} justify="flex-end">
              <Popover
                position="top"
                shadow="md"
                opened={commentRequiredPopoverOpened}
                withArrow
                classNames={{
                  dropdown: classes.commentRequiredPopover,
                }}
              >
                <Popover.Target>
                  <Indicator label={comments?.length} color="red" size={20}>
                    <Button
                      w={200}
                      size="lg"
                      radius={"md"}
                      onClick={open}
                      variant="light"
                      className={classes.commentBtnStyle}
                    >
                      + Comments
                    </Button>
                  </Indicator>
                </Popover.Target>
                <Popover.Dropdown>Required</Popover.Dropdown>
              </Popover>
            </Flex>
          </Box>

          <CommentDrawer
            title={"Comments"}
            opened={opened}
            close={close}
            comments={comments}
            setComments={setComments}
            data={selectedStaffData}
            taskTypeDetails={taskTypeDetails}
            commentRequiredPopoverClose={commentRequiredPopoverClose}
          />

          {/* <Box
            className={classes.mainContainer}
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
              margin: "20px",
            }}
          >
            <h3>Previous Notes</h3>
            <div className={classes.divGap}>
              <PreviousNotesComp notes={state?.notes} />
            </div>
          </Box> */}
        </form>
      </Box>
    </Container>
  );
};

export default AddTask;
